import Homework from "./Homework";
import React from "react";

export default (props) => <Homework {...props} teacherPage={false}/>;
